import React from 'react';
import { View, Text } from 'react-native';
import { useRoute, RouteProp, useNavigation } from '@react-navigation/native';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { useTeleassistanceDetail } from '../hooks/useTeleassistanceDetail';

type TParams = { TeleassistanceDetailScreen: { appointmentId: string } };

const DetailRow: React.FC<{ label: string; value?: string }> = ({ label, value }) => {
    if (!value) return null;
    return (
        <View className="mb-6">
            <Text className="font-semibold text-base text-primary-900 mb-1">{label}</Text>
            <Text className="text-base text-gray-800">{value}</Text>
        </View>
    );
};

const TeleassistanceDetailScreen: React.FC = () => {
    const { t } = dynamicTranslations();
    const navigation = useNavigation();
    const route = useRoute<RouteProp<TParams, 'TeleassistanceDetailScreen'>>();
    const { appointmentId } = route.params;

    const { detail, isFetching } = useTeleassistanceDetail(appointmentId);

    const s = 'teleassistance';

    return (
        <MainLayout navigation={() => navigation.goBack()} isLoading={isFetching} scrollable>
            <Text className="text-3xl font-bold text-primary-900 mb-8">
                {t(`${s}.detail.title`)}
            </Text>
            <DetailRow
                label={t(`${s}.detail.service`)}
                value={detail?.exam?.label}
            />
            <DetailRow
                label={t(`${s}.detail.preferredDate`)}
                value={detail?.preferredDate
                    ? t(`${s}.form.preferredDate.${detail.preferredDate}`)
                    : undefined}
            />
            <DetailRow
                label={t(`${s}.detail.preferredTime`)}
                value={detail?.preferredTime
                    ? t(`${s}.form.preferredTime.${detail.preferredTime}`)
                    : undefined}
            />
            <DetailRow
                label={t(`${s}.detail.additionalDetails`)}
                value={detail?.additionalDetails}
            />
        </MainLayout>
    );
};

export default TeleassistanceDetailScreen;
